import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "value"];

  connect() {
    console.log("HideSectionController#connect");
    this.sectionTarget.classList.add("hidden");

    this.handleUpdate();
  }

  handleUpdate() {
    const selectedInput = this.selectedInput();
    console.log(selectedInput, selectedInput.dataset.hideSectionVisibleValue == "true");

    if (selectedInput && selectedInput.dataset.hideSectionVisibleValue == "true") {
      this.sectionTarget.classList.remove("hidden");
    } else {
      this.sectionTarget.classList.add("hidden");
    }
  }

  selectedInput() {
    for (const el of this.valueTargets) {
      if (el.checked) {
        return el;
      }
    }
    return null;
  }
}
